// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"458":"95127d96","527":"cdfc3fc9","736":"fdc49a6d","993":"c9282096"}[chunkId] + ".css";
};